import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ChartsService } from '../../../../services/chartService/charts.service';
import { LineChartSpecification } from '../../../../dataModels/data-models';

declare var AmCharts;

@Component({
    moduleId: module.id,
    selector: 'basic-line-chart',
    templateUrl: 'basicLineChart.component.html',
    styleUrls: ['basicLineChart.component.css']
})

export class BasicLineChart implements OnInit {
    chart: any;
    @Input() chartSpecification: LineChartSpecification;
    drawIt: boolean = false;
    constructor(private chartsService: ChartsService) { }

    ngOnInit() {
        setTimeout(() => {
            this.chartsService.notifyMe.subscribe(() => this.drawChart());

            this.drawChart();
        }, 0);
    }

    drawChart() {
        let chartData;
        if (this.chartSpecification.countProperty)
            chartData = this.chartsService.groupByThenCount(this.chartSpecification.data, this.chartSpecification.xAxis,
                this.chartSpecification.countProperty);
        else if (this.chartSpecification.perTotalYAxisValue)
            chartData = this.chartsService.groupbyThenDivideSumBySum(this.chartSpecification.data,
                this.chartSpecification.xAxis, this.chartSpecification.value, this.chartSpecification.perTotalYAxisValue);
        else
            chartData = this.chartsService.groupByThenSumOrAvg(this.chartSpecification.data,
                this.chartSpecification.xAxis, this.chartSpecification.value, this.chartSpecification.perYAxisValue);

        chartData = this.chartsService.sortDatesAsc(chartData, this.chartSpecification.xAxis);
        this.drawIt = chartData.length > 0 ? true : false;

        let yAxisName = this.chartSpecification.value || 'Count';

        setTimeout(() => {
            this.chart = AmCharts.makeChart(this.chartSpecification.divId, {
                "type": "serial",
                "theme": "none",
                "marginRight": 40,
                "marginLeft": 40,
                "autoMarginOffset": 20,
                "mouseWheelZoomEnabled": true,
                "dataDateFormat": "YYYY-MM-DD",
                "valueAxes": [{
                    "id": "v1",
                    "axisAlpha": 0,
                    "position": "left",
                    "ignoreAxisWidth": true
                }],
                "balloon": {
                    "borderThickness": 1,
                    "shadowAlpha": 0
                },
                "titles": [
                    {
                        "text": this.chartSpecification.title,
                        "size": 15
                    }
                ],
                "graphs": [{
                    "id": "g1",
                    "balloon": {
                        "drop": true,
                        "adjustBorderColor": false,
                        "color": "#ffffff"
                    },
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": "#FFFFFF",
                    "bulletSize": 5,
                    "hideBulletsCount": 50,
                    "lineThickness": 2,
                    "title": "red line",
                    "useLineColorForBulletBorder": true,
                    "valueField": yAxisName,
                    "balloonText": "<span style='font-size:18px;'>[[value]]</span>"
                }],
                "chartScrollbar": {
                    "graph": "g1",
                    "oppositeAxis": false,
                    "offset": 30,
                    "scrollbarHeight": 80,
                    "backgroundAlpha": 0,
                    "selectedBackgroundAlpha": 0.1,
                    "selectedBackgroundColor": "#888888",
                    "graphFillAlpha": 0,
                    "graphLineAlpha": 0.5,
                    "selectedGraphFillAlpha": 0,
                    "selectedGraphLineAlpha": 1,
                    "autoGridCount": true,
                    "color": "#AAAAAA"
                },
                "chartCursor": {
                    "pan": true,
                    "valueLineEnabled": true,
                    "valueLineBalloonEnabled": true,
                    "cursorAlpha": 1,
                    "cursorColor": "#258cbb",
                    "limitToGraph": "g1",
                    "valueLineAlpha": 0.2,
                    "valueZoomable": true
                },
                "valueScrollbar": {
                    "oppositeAxis": false,
                    "offset": 50,
                    "scrollbarHeight": 10
                },
                "categoryField": this.chartSpecification.xAxis,
                "categoryAxis": {
                    "parseDates": true,
                    "dashLength": 1,
                    "minorGridEnabled": true
                },
                "export": {
                    "enabled": true
                },
                "dataProvider": chartData
            });
            this.chart.addListener("rendered", this.zoomChart);
            this.zoomChart();
        }, 20);
    }

    zoomChart() {
        this.chart.zoomToIndexes(this.chart.dataProvider.length - 40, this.chart.dataProvider.length - 1);
    }
}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/lineCharts/basicLineChart/basicLineChart.component.ts